import 'react-datepicker/dist/react-datepicker.css'

import ArrowIcon from '@assets/icons/arrow.svg?react'
import { enGB } from 'date-fns/locale/en-GB'
import DatePicker, { DatePickerProps } from 'react-datepicker'
import { registerLocale } from 'react-datepicker'

registerLocale('en-GB', enGB)

import s from './Datepicker.module.scss'

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

export function Datepicker(props: DatePickerProps) {
  return (
    <DatePicker
      locale="en-GB"
      inline
      fixedHeight
      calendarClassName={s.calendar}
      renderCustomHeader={({
        date,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
      }) => (
        <div className={s.header}>
          <button
            onClick={decreaseMonth}
            disabled={prevMonthButtonDisabled}
            className={s.prevBtn}
          >
            <ArrowIcon />
          </button>

          <div className={s.month}>{months[new Date(date).getMonth()]}</div>

          <button
            onClick={increaseMonth}
            disabled={nextMonthButtonDisabled}
            className={s.nextBtn}
          >
            <ArrowIcon />
          </button>
        </div>
      )}
      {...props}
    />
  )
}
